import axios, {
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.responseType = "json";

const requestBeforeInterceptor = async (req: InternalAxiosRequestConfig) => {
  const headers = req.headers || {};
  req.headers = headers;
  return req;
};

axios.interceptors.request.use(requestBeforeInterceptor, (x) =>
  Promise.reject(x),
);

export default class Fetcher {
  static get = async <ResponseType, D = any>(
    endpoint: string,
    config?: AxiosRequestConfig,
  ) => {
    const response = await axios.get<
      ResponseType,
      AxiosResponse<ResponseType>,
      D
    >(endpoint, config);
    return response.data;
  };

  static post = async <DataType, ResponseType>(
    endpoint: string,
    data?: DataType,
    config?: AxiosRequestConfig,
  ) => {
    const response = await axios.post<ResponseType>(endpoint, data, config);
    return response;
  };
}
